import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const fetchUserAddressDetailsActions = createDataModuleActions(
    'FETCH_USER_ADDRESS_DETAILS',
);
export const fetchUserAddressDetails =
    fetchUserAddressDetailsActions.dataRequest;
export const fetchUserAddressDetailsSuccess =
    fetchUserAddressDetailsActions.dataSuccess;
export const fetchUserAddressDetailsError =
    fetchUserAddressDetailsActions.dataError;
export const fetchUserAddressDetailsReset =
    fetchUserAddressDetailsActions.dataReset;
